export enum RoleAccess {
  // SPECIFIC = 'SPECIFIC',
  OWN = 'OWN',
  ALL = 'ALL'
}
export namespace RoleAccess {
  export function values() {
    return Object.keys(RoleAccess).filter(
      (type) => isNaN(type as any) && type !== 'values' && type !== 'enumObject'
    );
  }

  export function enumObject() {
    const enums: {
      key: string;
      value: RoleAccess | (() => string[]) | (() => any[]);
    }[] = [];
    values().forEach((elem) => {
      enums.push({
        key: elem,
        value: RoleAccess[elem as keyof typeof RoleAccess]
      });
    });
    return enums;
  }

//   export function getEnumValue(value: string) {
//     for (const elem of enumObject()) {
//       if (elem.value === value) {
//         return elem.key;
//       }
//     }
//   }
}
